<template>
<div
    data-tippy-content="Click to grant permissions"
    @click="$store.dispatch('requestIdShare')"
    class="grant-identity-helper">
    <span>{{ $t(i18nPath) }}</span>
    <FaIcon icon="exclamation-triangle" />
</div>
</template>

<script>
// Is this really necessary? Will non-english speakers understand without
// this helper?
import { mapGetters } from 'vuex'

import tippy from '@/tippy'

export default {
    name: 'GrantIdentityHelper',
    computed: {
        ...mapGetters([
            'isAnonymousUser',
            'isVideoComponentWindow',
        ]),
        i18nPath: vm => (
            vm.isAnonymousUser ? 'youMustLoginToPost' : 'youMustGrantIdToPost'
        ),
    },
    mounted () {
        if (!this.isVideoComponentWindow) { return }

        const tippyInstance = tippy(this.$el)
        this.$once('hook:destroyed', tippyInstance.destroy)
    },
}
</script>

<style lang="scss" scoped>
.grant-identity-helper {
    @include flex-center-children;
    cursor: pointer;
    height: 22px;
    padding: 2px 0;
    background-color: dimgrey;
    color: white;
    span {
        margin-right: 0.5rem;
    }
}
</style>
